// Product page script
Product = new Object();
Product.init = function () {
  Product.calculateDeliveryDate(5);
};

Product.calculateDeliveryDate = function (x) {
  var currentDate = new Date();
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(startDate, numDays) {
    var newDate = new Date(startDate);
    var businessDays = 0;

    while (businessDays < numDays) {
      newDate.setDate(newDate.getDate() + 1);
      // Check if the current day is a business day (Monday to Friday)
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        businessDays++;
      }
    }
    return newDate;
  }

  // Calculate the first delivery date (skipping weekends)
  var firstDeliveryDate = addBusinessDays(currentDate, x);
  var firstDayName = days[firstDeliveryDate.getDay()];
  var firstDay = firstDeliveryDate.getDate();
  var firstMonth = months[firstDeliveryDate.getMonth()];

  var firstFormattedDate = firstDayName + ', ' + firstDay + ' ' + firstMonth;
  // Display the formatted first delivery date
  $('.pr_product_shipping_delivered__js').text(firstFormattedDate);
}



$(document).ready(function () {
  Product.init();

  $('.pr_product_accord_line').click(function () {
    $(this).find('.pr_accord_info').slideToggle();
    $(this).toggleClass('active');
  });

  $('.ox_mn_btn').click(function (evt) {
    evt.preventDefault();

    $('html, body').animate({
      scrollTop: $(".pr_product_container").offset().top
    }, 500);

  });

  $('.pb_main_button').click(function (evt) {
    evt.preventDefault();

    $('html, body').animate({
      scrollTop: $(".pr_product_container").offset().top
    }, 500);

  });


  const wrapperClass = '.pr_quantity_selector';
  const switchPillOn = $(wrapperClass + ':has(.switch-pill)').length;
  // Separate variables for subscription and one-time purchase selections
  let selectedSub = !!$(wrapperClass + '.sub.active') || true;
  let selectedVar = $(wrapperClass + '.active .pr_product_var.active');
  let selectedFreq = 5710709016; // unused

  // Switch Sub/One-time
  $(wrapperClass + ':not(:has(.switch-pill))').click(function () {
    $(wrapperClass).removeClass('active');
    $(`${wrapperClass} .pr_product_outer`).hide();
    $(this).addClass('active');
    $(this).find('.pr_product_outer').show();
    selectedSub = !!$(this).hasClass('sub');
  });

  // Switch Sub/One-time with Switch-Pill
  $('.switch-pill input').click(function () {
    const isChecked = $('#set1').is(':checked');
    console.log(isChecked);
    if (isChecked) {
      $('.pr_product_outer.sub').show();
      $('.pr_product_outer.one-time').hide()
    } else {
      $('.pr_product_outer.sub').hide();
      $('.pr_product_outer.one-time').show()
    }
    selectedSub = isChecked;
  });

  // Quantity selection
  $(`${wrapperClass} .pr_product_var_outer_box`).click(function () {
    $(this).siblings().find('.pr_product_var').removeClass('active');
    $(this).find('.pr_product_var').addClass('active');
    selectedVar = $(this).find('.pr_product_var');
    if (selectedSub) updateSubPrice();
  });

  // Frequency selection
  $(`${wrapperClass + '.sub'} .variant__frequency-option`).click(function () {
    selectedFreq = $(this).data('plan-id');
    $(`${wrapperClass + '.sub'} .variant__frequency-option`).removeClass('active');
    $(this).addClass('active');
    updateSubPrice();
  });

  function updateSubPrice() {
    if (selectedVar && !switchPillOn) {
      const price = (selectedVar.data('price') / 100).toFixed(2);
      const compare = selectedVar.data('compare-price') || selectedVar.data('compare-price');
      const comparePrice = (compare / 100).toFixed(2);
      const saveAmount = (comparePrice - price).toFixed(2); // Ensure 2 trailing zeros


      const priceClass = wrapperClass + '.sub .pr_product_var_price_info';
      $(`${priceClass} s`).text(`$${comparePrice}`);
      $(`${priceClass} span`).text(`$${price}`);
      $(`${priceClass} .pr_var_price_badge`).text(`You're saving $${saveAmount}`);
    }
  }

  $(`${wrapperClass} .variant__frequency-option`)[0]?.click();
  $('.switch-pill input')[0]?.click();
  updateSubPrice();

  $('.pr_atc_btn').click(function (evt) {
    evt.preventDefault();
    const id = selectedVar.data('id');
    const selling_plan = selectedSub ? selectedFreq : undefined;
    const items = [{ id, quantity: 1, selling_plan }];
    console.log(items);

    // Add the items to the cart
    $.post("/cart/add.js", { items }, function () {
      buildCart();
      $("body").addClass("Overflow_hidden overflow-hidden");
      $('.nr_cart_drawer_outer').css('display', 'flex');

      setTimeout(() => {
        $('.nr_cart_drawer_outer').addClass('active');
      }, 100);
    }).fail(() => alert('Error adding the items to the cart.'));
  });
});
